import { prepareUserBalances } from "../../utils/PrepareUserBalances";

export function updateBalanceOnSocket(data) {
    return (dispatch, getState) => {
        //console.log('updateBalanceOnSocket', data)
        prepareUserBalances(dispatch, data, getState);
    }
}